import { _nullishCoalesce } from '@sentry/utils/esm/buildPolyfills';
import { generateUniqueID } from './generateUniqueID.js';

var initMetric = function initMetric(name, value) {
  return {
    name: name,
    value: _nullishCoalesce(value, function () {
      return -1;
    }),
    delta: 0,
    entries: [],
    id: generateUniqueID()
  };
};

export { initMetric };